import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps, MatrixColumnData } from '../types'

const matrixCharacters =
  'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'

export const MatrixRainEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#00ff00'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const textColor = effectColors[0] || '#00ff00'

  const [matrixColumns] = useState(() => {
    const columnCount = 30
    const newColumns: Array<MatrixColumnData> = []
    for (let i = 0; i < columnCount; i++) {
      const chars: string[] = []
      for (let j = 0; j < 20; j++) {
        chars.push(matrixCharacters[Math.floor(Math.random() * matrixCharacters.length)])
      }
      newColumns.push({
        id: i,
        x: (i / columnCount) * 100,
        characters: chars,
        delay: Math.random() * 5,
        duration: 3 + Math.random() * 2,
      })
    }
    return newColumns
  })

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {matrixColumns.map((column) => (
        <motion.div
          key={column.id}
          style={{
            position: 'absolute',
            left: `${column.x}%`,
            color: textColor,
            opacity: opacityValue,
            textShadow: `0 0 8px ${textColor}`,
            fontFamily: 'monospace',
            fontSize: '14px',
            fontWeight: 'bold',
          }}
          initial={{ top: '-100%' }}
          animate={{ top: '100%' }}
          transition={{
            duration: column.duration * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'linear',
            delay: column.delay,
          }}
        >
          {column.characters.map((char, charIndex) => (
            <div
              key={charIndex}
              style={{
                opacity: 1 - charIndex / column.characters.length,
              }}
            >
              {char}
            </div>
          ))}
        </motion.div>
      ))}
    </div>
  )
})
MatrixRainEffect.displayName = 'MatrixRainEffect'
